"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const labRequisitionTranslations = {
    labRequisitions: "Lab Requisitions",
    labRequisition: "Lab Requisition",
    noLabRequisitionsAvailable: "No lab requisitions available",
    noLabsFound: "No labs found. Please contact your administrator to configure labs.",
    recurring: "Recurring",
    orderDetails: "Order Details",
    noOrderDetailsAvailable: "No order details available",
    submit: "Submit",
    labOrderId: "Lab Order Id",
    copyOrderId: "Copy Order ID",
    copied: "Copied!",
    reports: "Reports",
    noReportsAvailable: "No reports available",
    submittedBy: "Submitted By",
    validationError: "Please fix the errors before submitting",
};
exports.default = labRequisitionTranslations;
